export const environment = {
  production: true,
  googleTrackingCode: 'G-PMNYF8JSG8', //'UA-112403980-1',
  version: require('../../package.json').version,
  maxCallLogsExportCount: 150000,
  facebookAppId: '453712126259073',
  facebookConfigId: '6950505391680529'
};
